import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Dashboard APIs
//TODO: Dashboard APIs
//  Get Dashboard Data
export const getDashboardAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.get(`${BASE_URL}dashboard`,  headers );
};
 
//  Get Dashboard Popular Products
export const getDashboardPopularProductsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}dashboard-popular-products`, data, headers );
};